function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var ActivitiesIcon = function ActivitiesIcon(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.9311 18.6226C10.8772 18.6226 9.85272 15.9313 9.85272 15.9313",
    stroke: color || '#333333',
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8721 18.6228C12.9261 18.6228 13.9505 15.9315 13.9505 15.9315",
    stroke: color || '#333333',
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9018 2C8.12737 2 5 4.90237 5 8.43799C5 11.2348 7.15681 13.0706 8.99009 14.7592V16.4591C8.99009 16.6174 9.09793 16.723 9.25969 16.723H14.5439C14.7056 16.723 14.8135 16.6174 14.8135 16.4591V14.7592C16.6467 13.0706 18.8036 11.2348 18.8036 8.43799C18.8036 4.90237 15.6762 2 11.9018 2Z",
    fill: "white",
    stroke: color || '#333333',
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5978 15.673H9.20581V16.7514H14.5978V15.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99017 15.5091V16.459C8.99017 16.6173 9.09801 16.7228 9.25977 16.7228H14.5439C14.7057 16.7228 14.8135 16.6173 14.8135 16.459V15.5091",
    stroke: color || '#333333',
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8783 6.75009C14.9594 7.41624 14.9999 8.13363 14.9999 8.85102C14.9999 11.6181 14.3918 13.9752 13.4999 15.0001",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8783 6.75009C14.9594 7.41624 14.9999 8.13363 14.9999 8.85102C14.9999 11.6181 14.3918 13.9752 13.4999 15.0001",
    stroke: color || '#333333',
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3846 15.0001C9.11532 13.9801 8.24994 11.6341 8.24994 8.88009C8.24994 5.20809 9.80763 2.25009 11.7692 2.25009C12.7499 2.25009 13.6153 3.01509 14.2499 4.18809",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3846 15.0001C9.11532 13.9801 8.24994 11.6341 8.24994 8.88009C8.24994 5.20809 9.80763 2.25009 11.7692 2.25009C12.7499 2.25009 13.6153 3.01509 14.2499 4.18809C14.2499 4.18809 14.8754 5.62509 14.8754 6.75009",
    stroke: color || '#333333',
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99994 15.0001L14.2499 15.0001",
    stroke: color || '#333333',
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1125 22.0003H9.69108C9.36756 22.0003 9.09796 21.7364 9.09796 21.4198V19.2034C9.09796 18.8868 9.36756 18.623 9.69108 18.623H14.1125C14.4361 18.623 14.7057 18.8868 14.7057 19.2034V21.367C14.7057 21.6837 14.4361 22.0003 14.1125 22.0003Z",
    fill: "white",
    stroke: color || '#333333',
    strokeMiterlimit: "10"
  }));
};